export var HubChannel;
(function(HubChannel) {
    HubChannel["NOTIFICATIONS"] = 'eclipsenotifications';
    HubChannel["NEW_FEEDBACK"] = 'mcfeedbacknew';
    HubChannel["DREAMSOFART"] = 'dreamsofart';
})(HubChannel || (HubChannel = {}));
